import Vue from 'vue'
//css per leafleft
import 'leaflet/dist/leaflet.css';

//Vue loading
import Loading from 'vue-loading-overlay'; //versione 3.0 https://github.com/ankurk91/vue-loading-overlay/tree/v3.x
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.component('loading', Loading)

// import VUE components
import OpenDataPanel from './components/OpenDataPanel.vue';
import Example from './components/example.vue';


//tutto eseguito 

(function($){
    window.$ = $;

    require('bootstrap');
    require('bootstrap-select/js/bootstrap-select');
    $.fn.selectpicker.Constructor.BootstrapVersion = "4.6.0";
    require("./scss/main.scss");
    //require('owl.carousel');
    //require('bootstrap-italia/src/js/plugins/fonts-loader');
    //require('bootstrap-italia/src/js/plugins/select');
    //require('bootstrap-italia/src/js/plugins/forms');
    //require('bootstrap-italia/src/js/plugins/datepicker/locales/it');
    //require('bootstrap-italia/src/js/plugins/datepicker/datepicker');
    //require('bootstrap-italia/src/js/plugins/carousel');

    // Facendo l'ovveride della funzione val di jquery possiamo lanciare la reazione di vue alla modifica dei componenti jquery
    var originalVal = $.fn.val;

    $.fn.val = function (value) {
        if (arguments.length >= 1) {
            if (value !== undefined && value != this[0].value) {
                var data = originalVal.apply(this, arguments);
                this[0].dispatchEvent(new Event('input'))
                this[0].dispatchEvent(new Event('change'))
                this[0].dispatchEvent(new Event('changed'))
                return data;
            }
        }
        return originalVal.apply(this, arguments);
    };

    const _ = require("lodash")
    window.lodash = _.noConflict();

    Vue.config.productionTip = false

    Vue.prototype.$buildGlobalHeaderAxios = function () {
        return {
            'Content-Type': 'application/json; charset=UTF-8'
        }
    };

    Vue.prototype.$jQueryWrapSelect = function () {

        let onSelectChange = function () {
            $(".dropdown-menu li.selected")
                .find('input[type="checkbox"]')
                .prop("checked", true);
            $(".dropdown-menu li:not(.selected)")
                .find('input[type="checkbox"]')
                .prop("checked", false);
        };

        // Allows to rewrite options dynamically with an object in the form of
        $.fn.setOptionsToSelect = function (optionsData) {
            var selectElement = $(this).find("select");

            // Destroying selectElement
            $(selectElement)
                .off("changed.bs.select")
                .selectpicker("destroy")
                .empty();

            // Appending options according to the optionsData object
            optionsData.forEach(function (x) {
                $(selectElement).append(
                    $("<option>", {
                        value: x.value,
                        text: x.text,
                    })
                );
            });

            // Refreshing selectElement
            $(selectElement)
                .selectpicker("refresh")
                .on("changed.bs.select", onSelectChange);

            return this;
        };

        // Bootstrap-select initialisation
        $(".bootstrap-select-wrapper select")
            .selectpicker()
            .on("changed.bs.select", onSelectChange);

        // Fixes for W3C and WCAG 2.0 compliance:
        var $selectWrapper = $(".bootstrap-select-wrapper");

        // Enter generic and non-visible text for empty options
        $selectWrapper
            .find("select option.bs-title-option")
            .text("Nessuna opzione");
        $selectWrapper.find("select option[data-content]").text("Annulla");

        // Remove the role="combobox" from the dropdown button
        $selectWrapper.find("button.dropdown-toggle").removeAttr("role");

        // Replace any <div>s elements with <span>s as <div>s are not allowed in a button element
        $selectWrapper.find("div.filter-option").replaceWith(function () {
            return $("<span />")
                .addClass("filter-option")
                .append($(this).contents());
        });
        $selectWrapper.find("div.filter-option-inner").replaceWith(function () {
            return $("<span />")
                .addClass("filter-option-inner")
                .append($(this).contents());
        });
        $selectWrapper
            .find("div.filter-option-inner-inner")
            .replaceWith(function () {
                return $("<span />")
                    .addClass("filter-option-inner-inner")
                    .append($(this).contents());
            });

        // Add title and WAI-ARIA attribute for the input search
        $selectWrapper
            .find(".bs-searchbox input")
            .attr("title", "Cerca")
            .attr("aria-expanded", "false");


    };

    let render_component = function (component, id, data) {

        new Vue({
            render: h => h(component, { props: data || {} })
        }).$mount(id);
    }

    ///// VUE DEFAULT SHORTCODES START

    ///// ##0 EXAMPLE
    window.render_example = function (id, dataValue) {
        return render_component(Example, id, dataValue);
    }

    ///// ##1 METADATI OPENDATA
    window.render_panel_opendata = function (id, dataValue) {
        return render_component(OpenDataPanel, id, dataValue);
    }    

    ///// VUE DEFAULT SHORTCODES END

    //// FUNCTION
    console.log('Hello World!!!')

})(window.jQuery);  